import React, { useState } from "react";
import "./Contact.css";
import axios from "axios";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
const Contact = () => {
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phn: "",
    message: "",
    dummy:"You’ve received a new message"
  });
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const serviceId = "service_y2wiyv9";
  //   const templateId = "template_9pz6455";
  //   const userId = "gHJShnDhyA9tSUzLk";

  //   emailjs
  //     .send(serviceId, templateId, formData, userId)
  //     .then(
  //       (result) => {
  //         setResponseMessage("Message sent successfully!");
  //         setFormData({
  //           name: "",
  //           email: "",
  //           phn: "",
  //           message: "",
  //         });
  //         toast.success("Message sent successfully!")
  //       },
  //       (error) => {
  //         setResponseMessage("Failed to send message. Please try again later.");
  //         toast.error("Failed to send message. Please try again later.")
  //       }
  //     );
  // };


  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true when submitting the form

    const serviceId = "service_y2wiyv9";
    const templateId = "template_9pz6455";
    const userId = "gHJShnDhyA9tSUzLk";


    emailjs
      .send(serviceId, templateId, formData, userId)
      .then(
        (result) => {
          setResponseMessage("Message sent successfully!");
          setFormData({
            name: "",
            email: "",
            phn: "",
            message: "",
          });
          toast.success("Message sent successfully!");
        },
        (error) => {
          setResponseMessage("Failed to send message. Please try again later.");
          toast.error("Failed to send message. Please try again later.");
        }
      )
      .finally(() => {
        setLoading(false); // Set loading to false after submission
      });
  };

  return (
    <>
      <div className="ugf-contact-header-bg">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="ugf-contact-header pt70">
                <h2>Contact us</h2>
                <p>We love to respond to your queries</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="ugf-contact-wrap">
                <div className="row">
                  <div className="col-lg-5 offset-lg-1">
                    <h2>Ask us anything here</h2>
                    <form id="commentForm" noValidate onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="inputText">Name</label>
        <input
          type="text"
          className="form-control"
          name="name"
          id="inputText"
          placeholder="e.g. John Doe"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="inputMail">Email Address</label>
        <input
          type="email"
          className="form-control"
          name="email"
          id="inputMail"
          placeholder="e.g. example@mail.com"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="inputPhone">
          Phone <span>(Optional)</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="phn"
          id="inputPhone"
          placeholder="e.g. +880 25896 336"
          value={formData.phn}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="inputTextarea">Message</label>
        <textarea
          id="inputTextarea"
          className="form-control"
          name="message"
          placeholder="Leave your message"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </div>
      <button type="submit" className="btn" disabled={loading}>
       {loading ? "Submitting.." : "Send Message"}
      </button>
      {/* {responseMessage && (
        <div className="response-message">
          <p>{responseMessage}</p>
        </div>
      )} */}
    </form>
                  </div>
                  <div className="col-lg-4 offset-xl-2 offset-lg-1">
                    <div className="contact-details">
                      <h2>Contact Info</h2>
                      <div className="contact-info">
                        <h5>Surgery Saathi Office</h5>
                        <p>
                          Sector 43 Gurgaon, Delhi Cantonment, and Indirapuram
                          Ghaziabad, Noida
                        </p>
                      </div>
                      <div className="contact-info">
                        <h5>Call Us</h5>
                        <ul>
                          <li>Mobile: +918882852726</li>
                          {/* <li>Hotline: 1800 - 1102</li> */}
                        </ul>
                      </div>
                      <div className="contact-info">
                        <h5>Mail Us</h5>
                        <ul>
                          <li>Info: info@surgerysaathi.com</li>
                          <li>Support: info@surgerysaathi.com </li>
                        </ul>
                      </div>
                      {/* <div className="contact-info">
                        <h5>Socila Networks</h5>
                        <div className="social-links">
                          <a href="#" className="facebook">
                            <i className="lab la-facebook-f" />
                          </a>
                          <a href="#" className="twitter">
                            <i className="lab la-twitter" />
                          </a>
                          <a href="#" className="instagram">
                            <i className="lab la-instagram" />
                          </a>
                          <a href="#" className="linkedin">
                            <i className="lab la-linkedin-in" />
                          </a>
                          <a href="#" className="youtube">
                            <i className="lab la-youtube" />
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
